import { MutationTree } from "vuex";
import { State } from "./applications.store";

const mutations: MutationTree<State> = {
  setTemplateMetrics(state: State, data: any) {
    state.templateMetrics = data;
  },
  setCurrentEvent(state: State, data: any) {
    state.currentEventItem = data;
  },
  setCurrentEventID(state: State, data: any) {
    state.currentEventID = data;
  },
  setAvailabilityTemplate: (state: State, data: any) => {
    state.chartTemplate = data
 }
};

export default mutations;
